import { NavLink } from 'react-router-dom';
import styled from 'styled-components';
import teal from 'sushiweb/tokens/color/teal';
import blue from 'sushiweb/tokens/color/blue';
import green from 'sushiweb/tokens/color/green';
import grey from 'sushiweb/tokens/color/grey';
import orange from 'sushiweb/tokens/color/orange';
import red from 'sushiweb/tokens/color/red';
import white from 'sushiweb/tokens/color/white';
import yellow from 'sushiweb/tokens/color/yellow';
import { P } from 'sushiweb/Typography/Text';

export const status = {
  0: 0,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
  5: 5,
  6: 6,
  '': 0,
  init: 1,
  Active: 1,
  initiated: 1,
  terminated: 2,
  Inactive: 2,
  Scheduled: 6,
  success: 4,
  Completed: 4,
  approved: 4,
  declined: 5,
  failed: 5,
  parked: 6,
};

const statusColors = {
  true: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  false: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  ACTIVE: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  INACTIVE: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  INVITED: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  PAUSED: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  0: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  1: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  3: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  4: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  INITIATED: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  ADDED: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  OPTED_IN: {
    background: yellow.z100,
    color: yellow.z500,
    border: yellow.z300,
  },
  REMOVED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  ON_HOLD: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  EXITED: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  ON_HOLD_NEEDS_UPGRADE: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  APPROVED: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  PENDING: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  DENIED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  DECLINED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  DELETED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  EXPIRED: {
    background: blue.z100,
    color: blue.z800,
    border: blue.z300,
  },
  NOT_STARTED: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  DRAFTED: {
    background: blue.z100,
    color: blue.z800,
    border: blue.z300,
  },
  COMPLETED: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  COMPLETED_ENDED: {
    background: orange.z100,
    color: orange.z600,
    border: orange.z300,
  },
  COMPLETED_SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  DELETED_SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  PAUSED_SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  ACTIVE_ONBOARDED: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  PLAN_ACTIVE: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  Completed: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  Inactive: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  ENQUEUED: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  INSUFFICIENT_FUNDS: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  GENERATED: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  GENERATED_SCHEDULED: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  GENERATED_UPCOMING: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  INITIATED_PROCESSING: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  FUNDS_AWAITED_AMOUNT_DUE: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  SCHEDULED: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  SCHEDULED_AMOUNT_PARKED: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  UNSPECIFIED: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  NO_ACTIVE_WALLET: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  TIMEOUT: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  PAYMENT_ERROR: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  DB_FAILURE: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  NOT_LINKED: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  TERMINATED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  INACTIVE_EMPLOYEE: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  INACTIVE_EMPLOYEE_GROUP_MAPPING: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  DUPLICATE_ATTEMPT: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  FAILED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  WALLET_CREATION_PENDING_ONBOARDING_PENDING: {
    background: teal.z100,
    color: teal.z600,
    border: teal.z300,
  },
  PENDING_WITH_PARTNER_PROCESSING: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  SYSTEM_FAILED_PROCESSING: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  ACCUMULATING: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  NON_ACCUMULATING: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  PARTIALLY_DONE: {
    background: teal.z50,
    color: teal.z600,
    border: teal.z300,
  },
  PROCESSING_IN_PROGRESS: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  TOPUP_EXPIRED_SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  INVALID_STATUS: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  INVALID_SUBSCRIPTION: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  CREDITS_EXPIRED: {
    background: blue.z100,
    color: blue.z800,
    border: blue.z300,
  },
  MOVED_PARKED_FUNDS: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  EXECUTION: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  ADDITION: {
    background: blue.z100,
    color: blue.z500,
    border: blue.z300,
  },
  CREDIT: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  DEBIT: {
    background: orange.z100,
    color: orange.z500,
    border: orange.z300,
  },
  TRANSACTION_SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  TRANSACTION_FAILED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  TRANSACTION_EXPIRED_FAILED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  ADDED_ONBOARDING_PENDING: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  OPTED_IN_ONBOARDING_INCOMPLETE: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  REMOVED_EXITED: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
  INITIATED_PENDING: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  APPROVED_SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  VOID_FAILED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  REFUNDED: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  PARTIALLY_REFUNDED: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  PLACED_SUCCESS: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  GENERATED_UNPAID: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  PARTIALLY_PAID: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  PAYMENT_PENDING: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  PAID: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  SETTLED_PAID: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  ORDER_PLACED_PAID: {
    background: green.z100,
    color: green.z500,
    border: green.z300,
  },
  ORDER_FAILED: {
    background: red.z100,
    color: red.z500,
    border: red.z300,
  },
  ORDER_REFUNDED: {
    background: yellow.z100,
    color: yellow.z800,
    border: yellow.z300,
  },
  ORDER_PARTIALLY_REFUNDED: {
    background: orange.z100,
    color: orange.z600,
    border: orange.z300,
  },
  default: {
    background: grey.z100,
    color: grey.z600,
    border: grey.z300,
  },
};

export const SampleEmployeeContainer = styled.div`
  margin: 2.8rem 0 4.2rem;
  width: 100%;
  p {
    font-size: 1.7rem;
  }
`;

export const DataFetchError = styled.div`
  width: 100%;
  padding: 6rem 0;
  margin: auto;
  flex-direction: column;
`;

export const Title = styled(P)`
  font-size: 2.4rem;
  text-align: center;
  margin: 2rem 0;
`;

export const SampleDataContainer = styled.div`
  margin: 1.4rem 0;
  width: ${props => (props.group ? '40%' : '85%')};
  background: ${white};
  border-radius: 0.6rem;
  border: 0.1rem solid ${grey.z200};
`;

export const TableClickContainer = styled(NavLink)`
  font-weight: 500;
  color: ${blue.z500};
  text-decoration: none;
  &:hover {
    opacity: 0.8;
  }
`;

export const DownloadInvoiceContainer = styled.div`
  display: flex;
`;

export const DownloadInvoiceWrapper = styled.div`
  height: 30px;
  width: 30px;
  padding: 5px 2px 5px 8px;
  background: ${white};
  border-radius: 6rem;
  margin: -5px 0px -10px 5px;
`;

export const CopyToClipboardClick = styled.div`
  font-weight: 500;
  padding-right: 10px;
  color: ${blue.z500};
  text-decoration: none;
  cursor: pointer;
  &:hover {
    opacity: 0.8;
  }
`;

export const CopyToClipboardTooltip = styled.div`
  width: 60px;
  background-color: #fff;
  color: ${grey.z500};
  text-align: center;
  border-radius: 6px;
  padding: 5px 0;

  position: absolute;
  margin-left: 90px;
  margin-top: -5px;
  z-index: 5;
`;

export const StatusContainer = styled.div`
  padding: 0.6rem 0.7rem;
  background: ${props =>
    (statusColors[props.status ? props.status : false] || statusColors.default)
      .background};
  color: ${props =>
    (statusColors[props.status ? props.status : false] || statusColors.default)
      .color};
  border: 0.5px solid
    ${props =>
      (
        statusColors[props.status ? props.status : false] ||
        statusColors.default
      ).border};
  width: ${props => (props.isNewLine ? '70px' : 'auto')};
  border-radius: 4px;
  font-size: 10px;
  font-family: Lexend-400;
  font-weight: 400;
`;

export const InvoiceOnlineContainer = styled.div`
  display: inline-flex;
  padding: 8px 10px;
  align-items: center;
  gap: 4px;
  border-radius: 5px;
  border: 0.5px solid ${red.z600};
  background: ${red.z500};
  cursor: pointer;
  color: white;
`;

export const InstructionLabel = styled.div`
  font-size: 1.5rem;
  color: ${grey.z500};
  &:before {
    display: inline;
    content: '*';
    color: ${red.z600};
    font-size: 2rem;
  }
`;

export const StyledDiv = styled.div`
  display: flex;
  flex-direction: column;
`;
